import React from 'react';
import { useQuery } from 'react-query';
import { Get } from '../../../../utils/httpProvider';
import { ACCOUNT_AUTHINFO_API } from '../../../../utils/apiUrl';

/**
 * Component hiển thị thông tin Cán bộ (Họ tên)
 * Thực hiện lấy dữ liệu từ Backend Auth (Port 5003) ngay tại Frontend.
 * Tận dụng React Query để cache dữ liệu, tránh gọi API lặp lại cho cùng 1 User.
 */
const UserInfoCell = ({ userId, firstName, middleName, lastName, userName }) => {
    // 1. Lấy Họ tên chi tiết từ AccountAuthInfo API (Port 5003)
    const { data: authInfo, isLoading: loadingAuthInfo } = useQuery(
        ['authInfo', userId],
        () => Get(ACCOUNT_AUTHINFO_API.GET_BY_ID_ACCOUNT, userId),
        {
            enabled: !!userId && !firstName,
            staleTime: 600000,
            cacheTime: 900000
        }
    );

    if (!userId) return <span className="text-muted">N/A</span>;
    
    if (loadingAuthInfo && !firstName) {
        return (
            <div className="d-flex align-items-center">
                <div className="spinner-border spinner-border-sm text-primary mr-2" role="status"></div>
                <small className="text-muted" style={{ fontSize: '0.8rem' }}>Đang tải...</small>
            </div>
        );
    }

    const fullName = firstName ? [lastName, middleName, firstName].filter(Boolean).join(' ') : ([
        authInfo?.lastName || authInfo?.LastName,
        authInfo?.middleName || authInfo?.MiddleName,
        authInfo?.firstName || authInfo?.FirstName
    ].filter(Boolean).join(' ') || 'Chưa cập nhật');

    const uName = userName || authInfo?.account?.username || authInfo?.Account?.UserName;

    return (
        <div className="d-flex flex-column">
            <span className="font-weight-bold text-dark" style={{ fontSize: '0.9rem' }}>{fullName}</span>
            {uName && <small className="text-muted" style={{ fontSize: '0.75rem' }}>{uName}</small>}
        </div>
    );
};

export default UserInfoCell;
